import type { Sticker } from '../types';

export const house: Sticker[] = [
  {
    id: 11001,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/001-house.png',
    name: 'Dom',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11002,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/002-house.png',
    name: 'Domek',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11003,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/003-house.png',
    name: 'Willa',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11004,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/004-house.png',
    name: 'Apartament',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11005,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/005-house.png',
    name: 'Rezydencja',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11006,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/006-house.png',
    name: 'Chata',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11007,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/007-house.png',
    name: 'Domek Letni',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11008,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/008-house.png',
    name: 'Bungalow',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11009,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/009-house.png',
    name: 'Domek na Wsi',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11010,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/010-house.png',
    name: 'Domek z Ogrodem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11011,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/011-house.png',
    name: 'Domek z Garażem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11012,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/012-house.png',
    name: 'Domek z Basenem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11013,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/013-house.png',
    name: 'Domek z Tarasem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11014,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/014-house.png',
    name: 'Domek z Balkonem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11015,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/015-house.png',
    name: 'Domek z Werandą',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11016,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/016-house.png',
    name: 'Domek z Kominkiem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11017,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/017-house.png',
    name: 'Domek z Altaną',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11018,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/018-house.png',
    name: 'Domek z Huśtawką',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11019,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/019-house.png',
    name: 'Domek z Ogrodzeniem',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 11020,
    url: 'https://stickers.nauczniaczek.pl/colections/13461155-house/png/020-house.png',
    name: 'Domek z Fontanną',
    category: 'house',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];